<template>
  <PgConfigProvider v-if="theme" :themeColor="themeColor" :colorHook="colorHook">
    <div id="main" class="app-main">
      <router-view></router-view>
    </div>
  </PgConfigProvider>
</template>

<script>
import { defineComponent, ref, computed, watch, onMounted, getCurrentInstance } from 'vue'
import { PgConfigProvider } from 'pangu-components-plus'

export default defineComponent({
  name: 'App',
  components: { PgConfigProvider },
  setup() {
    const instance = getCurrentInstance().proxy
    const store = instance.$store
    
    // 响应式数据
    const theme = ref(false)
    const themeColor = ref(null)
    
    // 默认主题配置
    const defaultTheme = {
      reunion: '#078BF1',
      union: '#c7a77b',
      link: '#25b8b6',
      jd: '#009ede',
    }
    
    // 计算属性
    const system = computed(() => {
      const systemObj = store.state.user.solutionInfo.theme
      console.info(systemObj, 'Current system theme')
      return systemObj
    })
    
    // 主题切换方法
    const hasGetSystemInfo = async (systemType) => {
      theme.value = false
      
      if (!systemType) return
      
      try {
        // 优化主题加载逻辑，使用映射减少重复代码
        const themeMap = {
          link: () => import('./themes/link.less'),
          union: () => import('./themes/union.less'),
          jd: () => import('./themes/jd.less'),
          reunion: () => import('./themes/reunion.less'),
        }
        
        const loadTheme = themeMap[systemType] || themeMap.union
        
        await loadTheme()
        
        theme.value = true
        themeColor.value = {
          '--color-primary': defaultTheme[systemType] || defaultTheme.union,
        }
      } catch (error) {
        console.error('主题加载失败:', error)
        // 降级到默认主题
        theme.value = true
        themeColor.value = {
          '--color-primary': defaultTheme.union,
        }
      }
    }
    
    // 颜色钩子函数
    const colorHook = (commix, primaryStyleVars) => {
      return {
        '--pg-table-row-hover-background-color': commix['--color-primary-light-6'],
        '--layout-main-background-color': '#f7f7f7',
        // 可根据需要启用其他样式变量
        // '--layout-header-organization-name-color': primaryStyleVars.value['--color-white'],
        // '--layout-header-organization-date-color': primaryStyleVars.value['--color-white'],
        // '--layout-header-font-color': primaryStyleVars.value['--color-primary'],
        // '--layout-header-background-color': commix['--color-primary-light-05'],
        // '--layout-header-border-color': commix['--color-primary-light-05'],
      }
    }
    
    // 监听系统主题变化
    watch(
      system,
      (newValue) => {
        console.info(newValue, 'Theme changed')
        hasGetSystemInfo(newValue)
      },
      { immediate: true }
    )
    
    // 生命周期
    onMounted(() => {
      // 传递 instance.proxy 而不是 instance，确保可以访问到 $axios
      store.dispatch('setSolution', instance)
    })
    
    return {
      theme,
      themeColor,
      colorHook,
    }
  },
})
</script>
